module.exports = __webpack_public_path__ + "static/media/alert-dark.3826438b.svg";